import React, {Component} from 'react'
import { Tag,Select,Modal,Button,message,Input,Popconfirm } from 'antd';
import { TweenOneGroup } from 'rc-tween-one';
import ButtonCheckBox from "../../components/ButtonCheckBox";
import website from "../../view/components/mediaInformation/img/website.png";
// import wechat from "../../view/components/mediaInformation/img/wechat.png";
// import microBlog from "../../view/components/mediaInformation/img/microBlog.png";
// import tiktok from "../../view/components/mediaInformation/img/tiktok.png";
import {getAllMediaGroup, getAllMedias, addMediaGroup, delMediaGroupByName} from "../../actions/newsActivityAction";
import './plansToplatform.css';
import {uuid} from "../../utils";
import {connect} from "react-redux";
const { Option } = Select;

/**
 * 拟发平台
 */
class PlansToplatform extends Component {
    constructor(props) {
        super(props);
        this.state={
            checkedDataData:props.data.simpleMedias,
            mediaGroupList:[],
            currentMediaGroupName:"",
            mediaGroupVisible: false,
            defaultGroup: props.data.defaultGroup
        };
        this.getShowTags(props.data.simpleMedias);
    }

    mediaClassify = {};

    checkedClassify={};

    // icon = {
    //     type_1:website,
    //     type_2:wechat,
    //     type_3:microBlog,
    //     type_5:tiktok,
    // };

    //选择平台的数据进行分类
    classify = (simpleMedias) =>{
        simpleMedias && simpleMedias.map(item => {
            if(!this.mediaClassify["type_" + parseInt(item.platform)]){
                this.mediaClassify["type_" + parseInt(item.platform)] = [item];
            }else{
                this.mediaClassify["type_" + parseInt(item.platform)].push(item);
            }
        });
        this.setState({});
    };

    //已选平台的数据进行分类
    classifyChecked = (simpleMedias) =>{
        this.checkedClassify={};
        simpleMedias && simpleMedias.map(item => {
            if(!this.checkedClassify["type_" + parseInt(item.platform)]){
                this.checkedClassify["type_" + parseInt(item.platform)] = [item];
            }else{
                this.checkedClassify["type_" + parseInt(item.platform)].push(item);
            }
        });
        this.setState({});
    };

    componentDidMount() {
        getAllMedias({},(data)=>{
            this.classify(data);
        });
        this.loadMediaGroup();
    }

    loadMediaGroup(){
        getAllMediaGroup().then(dto=>{
            this.setState({
                mediaGroupList:dto.data
            })
        })
    }

    //获取选择平台变化后的数据；
    getCheckDataData(data,dataType){
        this.checkedClassify[dataType]=data;

        //重新计算选中的 媒体数据；
        let checkedDataData=[];
        for(let attr in this.checkedClassify){
             if(this.checkedClassify[attr]){
                 checkedDataData=checkedDataData.concat(this.checkedClassify[attr]);
             }
        }
        this.setState({checkedDataData});
        //向外暴露changeSelectData方法，用于获取当前checkedDataData的值
        if(this.props.changeSelectData){
            this.props.changeSelectData(checkedDataData)
        }
    };

    /**
     * 获取已选平台变化后的数据；
     * @param tags
     */
    getShowTags(tags){
        this.classifyChecked(tags);
        let checkedDataData = [];
        for (let attr in this.checkedClassify) {
            if (this.checkedClassify[attr]) {
                checkedDataData = checkedDataData.concat(this.checkedClassify[attr]);
            }
        }
        this.setState({checkedDataData});
        if(this.props.changeSelectData){
            this.props.changeSelectData(checkedDataData)
        }
    }

    clearAllData(){
        this.checkedClassify={};
        this.setState({
            currentMediaGroupName:"",
            checkedDataData:[],
        });
        if(this.props.changeSelectData){
            this.props.changeSelectData([])
        }
    }
    

    render() {
        console.log(this.props.newSecondSelectColor)
        let publishPlatformChunks = [];
        if(window.sysConfig){
            let platforms = JSON.parse(window.sysConfig.getValueByKey("sys.media.platform", "[]"));
            if(platforms && platforms.length > 0){
                let allClassifyMap = {};
                let icons = {};
                platforms.map(platform=>{
                    allClassifyMap["type_" + platform.code] = platform.name;
                    icons["type_" + platform.code] = platform.icon;
                });

                for(let attr in allClassifyMap){
                    if(this.mediaClassify[attr] && this.mediaClassify[attr].length > 0){
                        publishPlatformChunks.push(
                            <div style={{width:"100%"}} key={uuid()}>
                                <div style={{margin:"12px 0px"}}>
                                    <img src={icons[attr]} width={40} height={40}/><span style={{marginLeft:"10px",color:"#727a8f"}}><b>{allClassifyMap[attr]}</b></span>
                                </div>
                                <ButtonCheckBox value={"code"} checkedData={this.checkedClassify[attr]} name={"name"} dataType={attr} getSelectData={this.getCheckDataData.bind(this)} dataSource={this.mediaClassify[attr]}/>
                            </div>);
                    }
                }
            }
        }else{
            message.error("配置获取错误");
        }

        return <div style={{width:'100%', padding:'20px'}}>
            <div className={"plansTop_title"}><div style={{float:'left'}}>已选平台</div><div style={{float:'right',cursor:"pointer"}} onClick={this.clearAllData.bind(this)}>清除选择</div></div>
            <div>
                <MediaEditableTagGroup getShowTags={this.getShowTags.bind(this)} dataSource={this.state.checkedDataData?this.state.checkedDataData:[]}/>
            </div>
            <div className={"plansTop_title"}>常用组合</div>
            <div>
                <Select
                    style={{ width: "200px" }}
                    allowClear={true}
                    value={this.state.currentMediaGroupName?this.state.currentMediaGroupName:""}
                    defaultValue={this.state.defaultGroup}
                    onChange={currentMediaGroupName=>{
                        let checkedDataData = this.state.checkedDataData;
                        this.state.mediaGroupList && this.state.mediaGroupList.map(mediaGroup=>{
                            if(mediaGroup.name === currentMediaGroupName){
                                checkedDataData = mediaGroup.medias;
                            }
                        });
                        this.classifyChecked(checkedDataData);
                        this.setState({
                            currentMediaGroupName,checkedDataData
                        });
                        if(this.props.changeSelectData){
                            this.props.changeSelectData(checkedDataData)
                            this.props.changeDefaultGroup(currentMediaGroupName)
                        }
                    }}
                    >
                    {this.state.mediaGroupList && this.state.mediaGroupList.map(mediaGroup=>{
                        return <Option key={mediaGroup.id} value={mediaGroup.name}>{mediaGroup.name}</Option>
                    })}
                </Select>
                <Button className="select" type={"primary"} onClick={()=>{
                    if(!this.state.checkedDataData || this.state.checkedDataData.length === 0 ){
                        message.error("请至少选择一个组合");
                        return;
                    }
                    this.setState({
                        mediaGroupVisible: true
                    })
                }} style={{marginLeft:"15px"}}>保存为常用组合</Button>
                 <style>
                        {`
            .ant-btn-primary{
            background-color:${this.props.newSecondSelectColor} !important;
            border-color:${this.props.newSecondSelectColor} !important;
            }
                             `}</style>
                {
                    (this.state.currentMediaGroupName && this.state.currentMediaGroupName.length > 0)?
                        <Popconfirm
                            placement="topRight"
                            title={"确定要删除"+this.state.currentMediaGroupName+"组合吗？"}
                            onConfirm={()=>{
                                delMediaGroupByName(this.state.currentMediaGroupName).then(dto=>{
                                    message.success("删除成功");
                                    this.checkedClassify={};
                                    this.setState({
                                        currentMediaGroupName:"",
                                        checkedDataData:[]
                                    });
                                    this.loadMediaGroup();
                                })
                            }}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button style={{marginLeft:"15px"}}>删除组合</Button>
                        </Popconfirm>
                        :
                        <Button onClick={()=>{message.warn("请先选择您要删除组合")}} style={{marginLeft:"15px"}}>删除组合</Button>
                }
            </div>
            <div>{publishPlatformChunks}</div>
            <Modal
                title={"保存为常用组合"}
                visible={this.state.mediaGroupVisible}
                onOk={()=>{
                    if(!this.state.currentMediaGroupName || this.state.currentMediaGroupName.length === 0){
                        message.error("请输入组合名称");
                        return;
                    }
                    let mediaGroup = {
                        name: this.state.currentMediaGroupName,
                        medias:this.state.checkedDataData
                    };
                    addMediaGroup(mediaGroup).then(dto=>{
                        if(dto.status != 200){
                            message.warn(dto.msg);
                        }else{
                            message.success("保存成功");
                            this.loadMediaGroup();
                        }
                    });
                    this.setState({
                        mediaGroupVisible: false
                    })
                }}
                onCancel={()=>this.setState({mediaGroupVisible: false})}
            >
                <Input
                    placeholder="请输入常用组合名称"
                    onChange={e=>this.setState({currentMediaGroupName:e.target.value})}/>
            </Modal>
        </div>
    }
}

export default PlansToplatform;


/**
 * 选中的媒体标签，展示组件，
 */
export class MediaEditableTagGroup extends Component {

    platforms;

    constructor(props){
        super(props);
        this.state = {
            tags: props.dataSource,
            inputVisible: false,
            inputValue: '',
        };
        if(window.sysConfig) {
            this.platforms = JSON.parse(window.sysConfig.getValueByKey("sys.media.platform", "[]"));
        }else{
            message.error("配置加载错误");
        }
    }

  componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            tags: nextProps.dataSource,
        })
  }

    handleClose = removedTag => {
        const tags = this.state.tags.filter(tag => tag !== removedTag);
        this.setState({ tags });
        this.props.getShowTags(tags);
    };

    forMap = (item,index) => {
        let icon = website;
        for (let i = 0; this.platforms && this.platforms.length > i; i++) {
            if(parseInt(item.platform) === parseInt(this.platforms[i].code)){
                icon = this.platforms[i].icon;
                break;
            }
        }
        const tagElem = (
            <Tag className={'custom'} key={uuid()}
                closable={this.props.closable}
                onClose={e => {
                    e.preventDefault();
                    this.handleClose(item);
                }}
            ><img width={'38px'} style={{marginLeft:'-19px'}} src={icon}/>
                {item.name}
            </Tag>
        );
        return (
            <span key={index} style={{ display: 'inline-block' }}>
        {tagElem}
      </span>
        );
    };

    render() {
        const {tags} = this.state;
        const tagChild = tags.map((item,index)=>(this.forMap(item,index)));
        return (
            <div className={"editableTag_container"} style={this.props.style}>
                <div>
                    <TweenOneGroup
                        enter={{
                            scale: 0.8,
                            opacity: 0,
                            type: 'from',
                            duration: 100,
                        }}
                        leave={{ opacity: 0, width: 0, scale: 0, duration: 200 }}
                        appear={false}
                    >
                        {tagChild}
                        <style>
                            {`
                   .custom  {
                   border-left: none !important;
                   }
                    `}
                        </style>
                    </TweenOneGroup>
                </div>
            </div>
        );
    }
}
MediaEditableTagGroup.defaultProps = {
    closable: true,
    style:{}
};